<template>
  <svg
    width="24px"
    height="24px"
    enable-background="new 0 0 24 24"
    version="1.1"
    viewBox="0 0 24 24"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#7F92A9">
      <path
        d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M12,22C6.5,22,2,17.5,2,12S6.5,2,12,2s10,4.5,10,10   S17.5,22,12,22z"
      />
      <path
        d="m12 7c1.1 0 2 0.9 2 2h2c0-1.9-1.3-3.4-3-3.9v-1.1h-2v1.1c-1.7 0.5-3 2-3 3.9 0 2.2 1.8 4 4 4 1.1 0 2 0.9 2 2s-0.9 2-2 2-2-0.9-2-2h-2c0 1.9 1.3 3.4 3 3.9v1.1h2v-1.1c1.7-0.4 3-2 3-3.9 0-2.2-1.8-4-4-4-1.1 0-2-0.9-2-2s0.9-2 2-2z"
      />
    </g>
  </svg>
</template>

<script>
  export default {};
</script>

<style scoped></style>
